import structuredClonePonyfill from '@ungap/structured-clone';

export function cloneValue<T>(value: T): T {
  return structuredClonePonyfill(value);
}
